import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.selectTarget(this.element.querySelector('[data-target].selected'));
    this.element.querySelectorAll('[data-target]').forEach(($el) => {
      $el.addEventListener('click', (ev) => this.selectTarget($el));
    });
  }

  selectTarget(el) {
    if (!el)
      return;

    document.querySelectorAll('.collapse-target').forEach((it) => it.classList.add('d-none'));
    document.querySelectorAll(el.dataset.target).forEach((it) => it.classList.remove('d-none'));
  }
};